import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FormRenderProps } from 'react-final-form';

import { Button, LinearProgress, CardContent, Card } from '@occc/ui-design-system';
import { FormLayout } from '@occc-app/routes/CampaignComponents/components/FormLayout';

import { FormContent } from '../components/FormContent';

interface UpdateUserFormRenderComponentProps extends Pick<FormRenderProps, 'handleSubmit'> {
  disabled: boolean;
  loading: boolean;
}

export const UpdateUserFormRenderComponent: React.FC<UpdateUserFormRenderComponentProps> = ({
  handleSubmit,
  disabled,
  loading,
}) => {
  const navigate = useNavigate();

  const actions = [
    <Button
      key='cancel'
      variant='outlined'
      role='button'
      color='primary'
      onClick={() => navigate(-1)}
    >
      Cancel
    </Button>,
    <Button
      key='save'
      variant='contained'
      color='primary'
      onClick={handleSubmit}
      disabled={disabled}
    >
      Save
    </Button>,
  ];

  return (
    <form onSubmit={handleSubmit} data-testid='user-update-form'>
      <Card>
        <FormLayout actions={actions}>
          {loading && <LinearProgress />}
          <CardContent>
            <FormContent />
          </CardContent>
        </FormLayout>
      </Card>
    </form>
  );
};
